import React from 'react';

function TimersIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="22"
      viewBox="0 0 19 22"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="#FFF" fillRule="nonzero" transform="translate(-171 -2143)">
          <g transform="translate(136 1975)">
            <g transform="translate(35 168)">
              <path d="M13.563 0c.75 0 1.357.615 1.357 1.374 0 .76-.607 1.375-1.357 1.375H10.85v.11a9.435 9.435 0 014.22 1.745c.075-.178.18-.341.313-.481l.895-.907c.622-.63 1.631-.63 2.253 0 .622.63.622 1.651 0 2.281l-.896.907c-.134.128-.29.23-.461.303a9.718 9.718 0 01-.221 11.64c-2.647 3.389-7.2 4.575-11.134 2.9C1.885 19.573-.463 15.448.077 11.162c.54-4.286 3.835-7.682 8.058-8.303v-.11H5.42c-.75 0-1.357-.616-1.357-1.375S4.671 0 5.42 0zM9.492 5.497c-3.748 0-6.786 3.077-6.786 6.872s3.038 6.872 6.786 6.872c3.747 0 6.785-3.077 6.785-6.872S13.24 5.497 9.492 5.497zM7.035 9.813a.726.726 0 01.978 0l1.357 1.21c.236-.101.49-.153.746-.152 1.15 0 2.085.942 2.09 2.107.005 1.166-.921 2.116-2.072 2.126-1.15.01-2.093-.924-2.108-2.09.002-.267.052-.533.15-.782L6.98 10.857a.692.692 0 01-.19-.536.732.732 0 01.244-.508z" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default TimersIcon;



// WEBPACK FOOTER //
// ./src/components/modules/Examples/Timers.js